import React, { useState, useEffect } from "react";
import { CoinList } from "../config/api";
import { CryptoState } from "../CryptoContext";
import axios from "axios";
import {
  LinearProgress,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { formatNumber, getCurrencySymbol } from "../utils/formatters";
import classNames from "./style.module.css";
import getColorsHook from "../getColorsHook";

const CoinsTable = () => {
  const [colors] = getColorsHook();
  const styles = {
    container: {
      margin: 30,
      background: colors.bgContrast,
      padding: 10,
      borderRadius: 6,
      color: colors.text1,
      overflow: "auto",
    },
  };
  const [coins, setCoins] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const history = useHistory();

  const { currency } = CryptoState();
  const fetchCoins = async () => {
    setLoading(true);
    const { data } = await axios.get(CoinList(currency));
    setCoins(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchCoins();
  }, [currency]);

  const handleSearch = () => {
    return coins.filter(
      (coin) =>
        coin.name?.toLowerCase().includes(search) ||
        coin.symbol?.toLowerCase().includes(search)
    );
  };

  return (
    <div style={styles.container} className={classNames.cointable}>
      <div
        style={{
          padding: "20px 50px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Search crypto..."
          variant="filled"
          onChange={(e) => setSearch(e.target.value)}
          // value={search}
          style={{
            background: colors.bg2,
            color: colors.text2,
            width: "80%",
            borderRadius: 6,
          }}
        />
      </div>

      <TableContainer>
        {isLoading ? (
          <LinearProgress style={{ background: "gold" }} />
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                {["Coin", "Price", "24h Change", "Market Cap"].map((head) => (
                  <TableCell key={head} style={{ color: colors.text1 }}>
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody style={{ color: "whitesmoke" }}>
              {handleSearch()
                .slice((page - 1) * 10, (page - 1) * 10 + 10)
                .map((row) => {
                  return (
                    <TableRow
                      onClick={() => history.push(`/coin/${row.id}`)}
                      key={row.name}
                      className={classNames.hoverItem}
                      style={{
                        cursor: "pointer",
                        "&: hover": { opacity: "30%" }, // TODO:
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        style={{
                          color: colors.text2,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ width: 60, marginRight: 10 }}>
                          <img src={row.image} alt="logo" height="40" />
                        </div>

                        {row.name}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        style={{ color: colors.text2 }}
                      >
                        {getCurrencySymbol(currency)}
                        {formatNumber(row.current_price)}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        style={{ color: colors.text2 }}
                      >
                        {formatNumber(row.price_change_percentage_24h)}%
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        style={{ color: colors.text2 }}
                      >
                        {getCurrencySymbol(currency)}
                        {formatNumber(row.market_cap)}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        )}
      </TableContainer>
      <Pagination
        count={handleSearch()?.length / 10}
        style={{
          padding: 20,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
        onChange={(_, value) => {
          setPage(value);
          window.scroll(0, 450);
        }}
        classes={{ ul: classNames.pagination }}
      />
    </div>
  );
};

export default CoinsTable;
